import { useEffect, useState } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";

/*
Handles displaying large chunks of data in sets of 50 rows at a time, so that the
UI isn't bogged down with tables that have thousands of rows.  Primarily used in all
the report tables.
*/

const PAGE_SIZE = 20;

export const useLocalPagination = (data) => {
  const [pageCount, setPageCount] = useState(1);
  const [currentData, setCurrentData] = useState([]);

  const handleBottomScroll = () => {
    if (pageCount < data.length / PAGE_SIZE) {
      setCurrentData(data.slice(0, (pageCount + 1) * PAGE_SIZE));
      setPageCount(pageCount + 1);
    }
  };

  const scrollRef = useBottomScrollListener(handleBottomScroll, {
    offset: 50,
    debounceOptions: {
      leading: true,
      trailing: false,
    },
  });

  useEffect(() => {
    setCurrentData(data.slice(0, PAGE_SIZE));
  }, [data]);

  return {
    scrollRef: scrollRef,
    reportData: currentData,
  };
};
